import { AxiosRequestConfig } from 'axios';
import { get, omit } from 'lodash';

import { billingTransactionBaseModel } from './crud';
import { TBillingTransaction } from './types';
import { QueryOptions, useCreateQuery } from '../../CRUD';
import { axiosService } from '../../services/axiosService';

export const useFetchAppointmentTransactionManyHook = (
  params?: AxiosRequestConfig['params'],
  options?: QueryOptions<AxiosRequestConfig['params']>,
  extraKey?: string,
) => {
  async function queryFn() {
    const { data } = await axiosService.get(
      `v2${
        billingTransactionBaseModel.keys.basicUrlPath
      }/appointments/patients/${get(params, 'id', '')}`,
      {
        params: omit(params, 'id'),
      },
    );
    return data;
  }

  return useCreateQuery<TBillingTransaction[]>(
    [...billingTransactionBaseModel.keys.many(), extraKey],
    queryFn,
    params,
    options,
  );
};
